<template>
  <div>
    <add-fromComputer @closePopup="onCancel" v-if="openPopover"></add-fromComputer>
    <ob-collapse :type="10" :expand="true">
      <h4
        class="h4_design"
        style=" font-weight: 600; color:#475259;font-size:13.5px;"
        slot="collapse-title"
      >
        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_attachments.svg`" style="padding-right:8px;" />
        Attachments and Links
      </h4>
      <div slot="collapse-icon-custom" class="collapse-icon-custom">
        <div
          style="font-size: 12px;font-weight: bold;display: block;"
          @click.stop="openPopover = !openPopover"
        >
          <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" />
          <span style="color:#464444;font-weight: 600;">Add</span>
        </div>
      </div>
      <div slot="collapse-details">
        <template v-for="(item,index) in Attachments">
          <div
            class="attachments-view1"
            v-if="item.Content != '' && item.Content != null"
            v-on:mouseover="mouseOverCheck = item.Id"
            v-on:mouseout="mouseOverCheck = ''"
            :id="item.Id"
          >
            <template v-if="isFile(item.Content)">
              <img
                style="margin-bottom: 6px;margin-right: 6px;"
                v-bind:src="mouseOverCheck === item.Id ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_document-hover.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_document.svg`"
              />
              <span id="task-title">{{getFileName(item.Content)}}</span>
              <ob-popover trigger="click" :options="{placement: 'bottom'}">
                <div class="popper" style="padding:0px">
                    <div style="padding:10px;">
                        <span :class="{'cursorCls': !isFileType(item.Content)}" >
                          <span :class="{'hideShow': !isFileType(item.Content)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item.Content)" /></span>
                        </span>
                        <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item.Content)" /></span>
                        <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item.Content)" /></span>
                    </div>
                </div>
                <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-left:10px" />
            </ob-popover>
            </template>
            <template v-else>
              <img
                style="margin-bottom: 6px;margin-right: 6px;"
                v-bind:src="mouseOverCheck === item.Id ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_link-hover.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_link.svg`"
              />
              <span @click="linkUrl(item)" id="task-title">{{getFileName(item.Content)}}</span>
            </template>
            <span
              style="margin-top: -25px; padding-top: 2px;padding-bottom: 6px;margin-left: 0px;margin-right: 10px;"
            >
              <span
                class="cross-mark"
                @click="confirmDeleteAttachement(item.Id , index)"
                style="font-size: 11px; padding: 2px 5px;"
              >&#10006;</span>
            </span>
          </div>
        </template>
      </div>
    </ob-collapse>
  </div>
</template>

<script>
import AddFromComputer from "./AddFromComputer.vue";
import c from "Vue/Core/constants.js";
import utils from "Vue/Core/utils.js";
import CommonFunctionMixin from '../Timesheets/CommonFunctionMixin.js'
export default {
  mixins: [CommonFunctionMixin],
  props: ["content", "attachments"],
  data() {
    return {
      selectedIndex: "",
      openPopover: false,
      isUploading: false,
      clonedContent: null,
      Link: "",
      mouseOverCheck: "",
      Links: [],
      Attachments: []
    };
  },
  components: {
    "add-fromComputer": AddFromComputer
  },
  watch: {
    tools(val) {
      if (val.length > 0) {
        this.ToolsList = val;
      }
    }
  },
  computed: {
    CreatedBy() {
      return this.loggedInUserObj.Name;
    }
  },
  watch: {
    attachments(val) {
      this.Attachments = val;
    }
  },
  created() {
    this.Attachments = this.attachments;
  },
  methods: {
    onCancel() {
      this.openPopover = false;
    },
    isFile(item) {
      var filename = utils.I9URL2FileName(item);
      var fileExtention = filename.split(".").pop();
      var FileTypes = [
        "pdf",
        "zip",
        "doc",
        "docx",
        "png",
        "gif",
        "jpg",
        "jpeg",
        "xls",
        "xlsx"
      ];
      return FileTypes.indexOf(fileExtention) > -1;
    },
    getFileName(item) {
      var isFile = this.isFile(item);
      if (isFile) {
        var filename = utils.I9URL2FileName(item);
      } else {
        var filename = utils.FilterExternalLinkURL(item);
      }
      var fileLength = filename.length;
      if (fileLength > 33) {
        return filename.substring(0, 30) + "...";
      } else return filename;
    },
    isFileType(item)
      {
        var filename = utils.I9URL2FileName(item);
        var fileExtention = filename.split('.').pop();
        var FileTypes = ["pdf", "png", "gif", "jpg", "jpeg"];
        return FileTypes.includes(fileExtention)
      },
    guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },
    addAttachment(obj) {
      var attachmentLinks = [];
      var objType = typeof obj;
      if (objType == "string") {
        var link = {
          Link: obj
        };
        attachmentLinks.push(link);
      } else {
        for (var i = 0; i < obj.length; i++) {
          var link = {
            Link: obj[i]
          };
          attachmentLinks.push(link);
        }
      }
      var Attachmentobj = {
        AttachmentLinks: attachmentLinks,
        Type: 2
      };
      this.$parent.$parent.UnTrustedLink = obj
      this.$parent.$parent.Attachmentlinks = Attachmentobj
      this.$parent.$parent.commanServiceForUpdate(Attachmentobj, obj);
      this.openPopover = false;
    },
    open() {
      setTimeout(() => {
        this.$refs.upload.uploadNew();
        //this.attachFile = true
      }, 1000);
    },

    linkUrl(item) {
      var url = item.Content;
      var containshttp = url.includes("http");
      var containshttps = url.includes("https");
      if (containshttp || containshttps) {
        window.open(url, "_blank");
      } else {
        var link = "https://" + url;
        window.open(link, "_blank");
      }
    },
    confirmDeleteAttachement(id, index) {
      this.selectedIndex = index;
      this.$alert2("Are you sure you want to delete ?", "Alert", {
        type: "confirm",
        yesButtonText: "Yes",
        noButtonText: "No",
        callback: action => {
          if (action === true) {
            var deleteObject = {
              Type: 2,
              TaskId: this.content.TaskId,
              ResourceId: id
            };
            this.$parent.$parent.deleteResource(deleteObject);
          }
        }
      });
    },
    deleteAttachement() {
      this.Attachments.splice(this.selectedIndex, 1);
      this.$message({
        type: "success",
        message: ResourceCore.Messages["Attachments_Deleted"]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.attachemnt-icon {
  font-size: 18px;
}
#computer {
  font-weight: 600;
  font-size: 12px;
  &:hover,
  &:active,
  &:focus {
    color: #4a90e2;
    text-decoration: underline !important;
  }
}
#past {
  font-weight: 600;
  font-size: 12px;

  &:hover,
  &:active,
  &:focus {
    color: #4a90e2;
    text-decoration: underline !important;
  }
}

.attachments-view1 {
  font-weight: unset !important;
  font-size: 15px;
  margin-top: 5px;
  margin-left: 0px;
  padding: 5px 10px;
  display: inline-block;
}
.attachments-view1:hover > #task-title {
  color: #4a90e2;
  text-decoration: underline !important;
  cursor: pointer;
}
.cross-mark-span {
  font-weight: unset !important;
  font-size: 15px;
  margin-top: 5px;
  margin-left: 0px;
  padding: 5px 10px;
  display: inline-block;
  border-radius: 30px;
  // float: left;
  margin-right: 2%;
}
.cross-mark {
  font-size: 15px;
  padding: 0px 5px;
  border-radius: 100%;
  cursor: pointer;
}
.cross-mark:hover {
  background: #c2c2c2;
  padding: 0px 5px;
  border-radius: 100%;
  text-decoration: none !important;
}
.remove-doc {
  color: #D0032E;
  font-size: 12px;
  font-style: italic;
  font-weight: bolder;
  text-decoration: underline;
  /* float: right; */
}
.add-doc {
  font-size: 12px;
  font-style: italic;
  font-weight: bolder;
  text-decoration: underline;
  color: #4a92e8;
}
.cursorCls
  {
    cursor:not-allowed !important;
  }
  .hideShow
  {
    pointer-events: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/Attachments.vue